var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7064 12.707C14.5189 12.8945 14.2646 12.9998 13.9994 12.9998C13.7343 12.9998 13.48 12.8945 13.2924 12.707L9.99943 9.41403L6.70643 12.707C6.51783 12.8892 6.26523 12.99 6.00303 12.9877C5.74083 12.9854 5.49002 12.8803 5.30461 12.6948C5.1192 12.5094 5.01403 12.2586 5.01176 11.9964C5.00948 11.7342 5.11027 11.4816 5.29243 11.293L9.29243 7.29303C9.47996 7.10556 9.73427 7.00024 9.99943 7.00024C10.2646 7.00024 10.5189 7.10556 10.7064 7.29303L14.7064 11.293C14.8939 11.4806 14.9992 11.7349 14.9992 12C14.9992 12.2652 14.8939 12.5195 14.7064 12.707Z",
    fill: "currentColor"
  })));
};
export default SvgChevronUp;